import { Loading } from '@carbon/react';

import styles from 'theme/components/overlay-loader.module.scss';

const OverlayLoader = ({ isLoading, small = false }) => (
  <div className={styles.wrapper}>
    <Loading small={small} active={isLoading} withOverlay />
  </div>
);

export default OverlayLoader;
